import { useNavigate } from "react-router-dom";
import { ArrowLeft, Crown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { RatesSection } from "./RatesSection";

const Rates = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="rates-page" className="pt-32 pb-28 lg:pt-36">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <Reveal y={14}>
          <button
            type="button"
            data-testid="rates-back-button"
            onClick={() => navigate("/account")}
            className="group inline-flex items-center gap-2 text-sm font-semibold text-navy"
          >
            <ArrowLeft className="h-4 w-4 text-bark transition-transform duration-200 group-hover:-translate-x-1" aria-hidden="true" />
            Back to my account
          </button>
          <p className="mt-6 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-bark">
            <span className="h-px w-10 bg-bark" aria-hidden="true" />
            Pricing
          </p>
          <h1 className="mt-4 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
            Our <em className="font-editorial italic text-bark">rates</em>
          </h1>
        </Reveal>
        <Reveal delay={0.05}>
          <RatesSection />
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="plans-cta"
            className="mt-10 flex flex-wrap items-center justify-between gap-6 rounded-[2rem] bg-navy px-7 py-8 sm:px-10"
          >
            <div className="flex items-center gap-4">
              <span className="rounded-full bg-amberwarm/15 p-3 text-amberwarm">
                <Crown className="h-6 w-6" aria-hidden="true" />
              </span>
              <div>
                <p className="font-display text-xl font-medium text-cream">Plans for your pack are on their way</p>
                <p className="text-sm text-cream/60">
                  Every pup gets their own plan — perfect when siblings have different needs. Details announced soon.
                </p>
              </div>
            </div>
            <span className="rounded-full border border-cream/20 px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-cream/70">
              Coming soon
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Rates;
